/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ScopeDefinition,
  ScopeDefinition$inboundSchema,
} from "./scopedefinition.js";

export type ListScopesResult = {
  /**
   * The scopes available in access control.
   */
  scopes: Array<ScopeDefinition>;
};

/** @internal */
export const ListScopesResult$inboundSchema: z.ZodMiniType<
  ListScopesResult,
  unknown
> = z.object({
  scopes: z.array(ScopeDefinition$inboundSchema),
});

export function listScopesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListScopesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListScopesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListScopesResult' from JSON`,
  );
}
